<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  @if (permissionService.hasPermission(permissionService.Permission.medium_group_create)) {
    <button
      type="button"
      sbTooltip="{{ 'lang.roleManagement.newRole' | translate }}"
      container="body"
      (click)="createRole()"
      sb-button-primary
      [color]="'green'"
      [iconButton]="true"
      [icon]="'plus'"
      [loading]="loading()"
    >
    </button>
  }

  <button
    (click)="requestDebounced()" [disabled]="loading()"
    sb-button-primary [color]="'blue'"
    [loading]="loading()"
    type="button"
    [iconButton]="true"
    [icon]="'refresh'"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}"
    container="body"
    placement="top">
  </button>
</ng-container>

<!------------------------------

    Table wrapper

------------------------------->

@let isExpanded = checkExpansion();
@let ordering = orderOption();

<div class="tw-min-h-[500px]">
  <sb-table-wrapper-new
    headline="{{'lang.headlines.roles' | translate}}" [itemsData]="roles()"
    (paginationChange)="requestDebounced($event)"
    [loading]="loading()" [itemName]="'mediumGroups'"
    [isFilterPanelOpen]="isExpanded">

    <!------------------------------

      Filter

  ------------------------------->
    <div filter-panel class="dark:tw-bg-sbGray-930 tw-bg-[#F8F9FC] tw-rounded-l-xl">
      <sb-filter-panel
        #FilterPanelRef
        (filterChange)="applyFiltering($event)"
        [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
        [config]="filterConfig"
        filterID="search"
      >
        <sb-filter-section
          title="{{'lang.globals.filterAttributes' |translate}}" icon="wrench"
          classes="tw-flex tw-flex-col tw-gap-2">
          <sb-filter-threeway-toggle filterID="owned" [default]="null"
                                     [label]="'lang.attributeToggles.roles.owned' | translate"></sb-filter-threeway-toggle>
        </sb-filter-section>
      </sb-filter-panel>
    </div>
    <!------------------------------

       Table Header

  ------------------------------->
    <ng-template #thead>
      <tr>
        <th class="table--sortable" (click)="setToOrderAndRefresh(ca_am_Role_retrieveAll_order.ID)"
            [ngClass]="{'table--sorted': ordering?.value === ca_am_Role_retrieveAll_order.ID}">
          {{ 'lang.globals.id' | translate }}
          @if (ordering.value === ca_am_Role_retrieveAll_order.ID) {
            @if (ordering.direction === 'desc') {
              <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            }
          } @else {
            <sb-icon
              icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
          }
        </th>
        <th class="table--sortable" (click)="setToOrderAndRefresh(ca_am_Role_retrieveAll_order.NAME)"
            [ngClass]="{'table--sorted': ordering?.value === ca_am_Role_retrieveAll_order.NAME}">
          {{ 'lang.globals.name' | translate }}
          @if (ordering.value === ca_am_Role_retrieveAll_order.NAME) {
            @if (ordering.direction === 'desc') {
              <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            }
          } @else {
            <sb-icon
              icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
          }
        </th>
        <th>{{ 'lang.globals.inheritedRoles' | translate }}</th>
        <th>{{ 'lang.roleManagement.explicitPermissions' | translate }}</th>
        <th class="sticky-col last-col">{{ 'lang.globals.action' | translate }}</th>
      </tr>
    </ng-template>

    <!------------------------------

      Table Body

  ------------------------------->
    <ng-template #tbody let-role>

      <tr>
        <td>
          {{ role?.id }}
        </td>
        <td>
          {{ role?.name | sbDefaultRoleTranslate }}
        </td>
        <td>
          <ng-container *ngFor="let inheritedRole of role?.inheritedRoles; index as i; last as last">
            <span *ngIf="i < 4 && !last">{{ inheritedRole.name | sbDefaultRoleTranslate }}, </span>
            <span *ngIf="i < 4 && last">{{ inheritedRole.name | sbDefaultRoleTranslate }}</span>
            <span *ngIf="i === 4">... ({{
                'lang.globals.countMore' | translate: {
                  count:
                    role.inheritedRoles.length - 4
                }
              }})</span>
          </ng-container>
        </td>
        <td>
          <ng-container *ngFor="let s of role?.explicitPermissions; index as i; last as last">
            <span *ngIf="i < 4 && !last">{{ s | sbPermissionTranslate }}, </span>
            <span *ngIf="i < 4 && last">{{ s | sbPermissionTranslate }}</span>
            <span *ngIf="i === 4">... ({{
                'lang.globals.countMore' | translate: {
                  count:
                    role.explicitPermissions.length - 4
                }
              }})</span>
          </ng-container>
        </td>
        <td class="sticky-col last-col">
          <sb-split-button
            [splitButtonItems]="role?.sbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(role, $event)"
          ></sb-split-button>
        </td>
      </tr>
    </ng-template>

    <!------------------------------

    Card Element

  ------------------------------->

    <!-- no card element -->

  </sb-table-wrapper-new>
</div>
